import InfoTooltipIcon from '@/components/icons/InfoTooltipIcon';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Divider,
  Switch,
  Typography,
} from '@mui/material';

const ManagePortfolioAnalysisSubscription = ({
  account,
  subscription,
  updatePortfolioAnalysis,
  subscriptionIsLoading,
  subscriptionError,
  createSubscription,
  isPortfolioAnalysisPostLoading,
}) => {
  const defaultSubscription = {
    account_id: account.AccountId,
    water: false,
    heat: false,
    power: true,
    default_daytime_start: 8,
    default_daytime_end: 16,
    demo_account: false,
  };

  const hasPortfolioService = account.Services?.some((s) => s.Id === 5);
  const is404 = subscriptionError?.status === 404;
  const is500 = subscriptionError?.status === 500;

  const renderErrorOrMissingState = () => {
    if (subscriptionIsLoading) return <CircularProgress />;
    if (is500)
      return <Alert severity="error">Der skete en uventet fejl.</Alert>;
    if (is404) {
      return hasPortfolioService ? (
        <Alert
          action={
            <Button onClick={() => createSubscription(defaultSubscription)}>
              Opret
            </Button>
          }
          severity="warning"
        >
          Der er ikke oprettet en portefølje subscription på denne konto.
        </Alert>
      ) : (
        <Button
          variant="contained"
          onClick={() => createSubscription(defaultSubscription)}
        >
          Opret
        </Button>
      );
    }
    return null;
  };

  const renderSubscriptionControls = () => {
    if (!subscription) return null;

    return (
      <>
        {!hasPortfolioService && (
          <Alert severity="warning">
            Porteføljeanalyse service er slået fra.
          </Alert>
        )}

        {hasPortfolioService &&
          !subscription.power &&
          !subscription.heat &&
          !subscription.water && (
            <Alert severity="warning">
              Porteføljeanalyse service er slået til men har ingen analyser.
            </Alert>
          )}

        {['power', 'heat', 'water'].map((type, index) => {
          const update = {
            ...subscription,
            [type]: !subscription[type],
          };

          return (
            <Box key={type}>
              {index > 0 && <Divider sx={{ mx: 1 }} />}
              <Box display="flex" alignItems="center" sx={{ pl: 2, mb: 1 }}>
                <Typography variant="body2" sx={{ flexGrow: 1 }}>
                  {type}
                </Typography>
                <Switch
                  checked={subscription[type]}
                  onChange={() => updatePortfolioAnalysis(update)}
                  inputProps={{ 'aria-label': `toggle ${type}` }}
                />
              </Box>
            </Box>
          );
        })}
      </>
    );
  };

  return (
    <>
      <HeaderDisplay
        label={'Portfolio Analysis subscription'}
        isLoading={isPortfolioAnalysisPostLoading}
      />
      {renderErrorOrMissingState()}
      {renderSubscriptionControls()}
    </>
  );
};

export default ManagePortfolioAnalysisSubscription;
const HeaderDisplay = ({ label, description, isLoading }) => {
  return (
    <Box display={'flex'} justifyContent={'space-between'}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          mb: 2,
        }}
      >
        <Typography variant="body1" color="textSecondary" fontWeight="bold">
          {label}
        </Typography>
        {description && <InfoTooltipIcon title={description} />}
      </Box>
      {isLoading && <CircularProgress size={16} />}
    </Box>
  );
};
